import { createRouter, createWebHashHistory } from 'vue-router'
//import store from '../store';

import FlowView from '../views/FlowView.vue'
import PermissionView from '../views/PermissionView.vue'
import UserView from '../views/UserView.vue'
import LoginView from '../views/LoginView.vue'
import LovView from '../views/LovView.vue'
import ReportView from '../views/ReportView.vue'
import MapView from '../views/MapView.vue'
import UnAuthView from '../views/UnAuthView.vue'
import DashboardView from '@/views/DashboardView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: MapView,
    meta: { showMainMenu: true, requiresAuth: true, view: 'View Map' },
  },
  {
    path: '/flow',
    name: 'flow',
    component: FlowView,
    meta: { showMainMenu: true, requiresAuth: true, view: 'View Flow' },
  },
  {
    path: '/user',
    name: 'user',
    component: UserView,
    meta: { showMainMenu: true, requiresAuth: true, view: 'View User' },
  },
  {
    path: '/permission',
    name: 'permission',
    component: PermissionView,
    meta: { showMainMenu: true, requiresAuth: true, view: 'View Permission' },
  },

  {
    path: '/lov',
    name: 'lov',
    component: LovView,
    meta: { showMainMenu: true, requiresAuth: true, view: 'View LOV' },
  },
  {
    path: '/report',
    name: 'report',
    component: ReportView,
    meta: { showMainMenu: true, requiresAuth: true, view: 'View Report' },
  },
  {
    path: '/map',
    name: 'map',
    component: MapView,
    meta: { showMainMenu: true, requiresAuth: true, view: 'View Map' },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: { showMainMenu: true, requiresAuth: false },
  },
  {
    path: '/dashboard/:id',
    name: 'detaildashboard',
    component: DashboardView,
    meta: { showMainMenu: true, requiresAuth: false },
  },
  {
    path: '/masuk',
    name: 'masuk',
    component: LoginView,
    meta: { showMainMenu: false, requiresAuth: false },
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: UnAuthView,
    meta: { showMainMenu: true, requiresAuth: false },
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) { // Periksa jika route memerlukan otentikasi

    if (localStorage.user != undefined) {
      const user = JSON.parse(localStorage.user)

      var user_permission = []
      user.permissions.map((role) => {
        if (role.module_name == "Web Putra") {
          user_permission = role.permissions.split(",")
        }
      })
    }

    if (localStorage.auth_token) { // Pastikan ada token otentikasi

      console.log("user_permission", user_permission)
      if (user_permission.indexOf(to.meta.view) != -1) {
        next(); // Lanjutkan navigasi ke route yang diinginkan
      } else {
        next('/forbidden');
      }

    } else {
      next('/masuk'); // Redirect ke halaman login jika tidak ada token
    }
  } else {
    next(); // Lanjutkan ke route jika tidak memerlukan otentikasi
  }
});

export default router
